import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSearch = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_2:863)">
          <path
            d="M1.47208 13.357C2.41223 15.5691 4.19265 17.3172 6.42168 18.2167C8.6507 19.1161 11.1457 19.0933 13.3579 18.1531C15.5701 17.213 17.3182 15.4326 18.2176 13.2035C19.1171 10.9745 19.0942 8.47948 18.1541 6.26731C17.2139 4.05514 15.4335 2.30705 13.2045 1.4076C10.9754 0.508144 8.4804 0.531006 6.26824 1.47116C4.05607 2.4113 2.30798 4.19173 1.40852 6.42075C0.50907 8.64978 0.531933 11.1448 1.47208 13.357V13.357Z"
            stroke="currentColor"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.2211 16.22L23.2501 23.25"
            stroke="currentColor"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2:863">
            <rect width={24} height={24} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconBase>
  );
};

SvgSearch.displayName = 'SvgSearch';
export default SvgSearch;
